class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimeout = null;
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

    this.addEventListener('mouseenter', this.onPointerEnter.bind(this));
    this.addEventListener('mouseleave', this.onPointerLeave.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
  }

  isDesktopHover() {
    return this.hoverMediaQuery.matches;
  }

  onPointerEnter() {
    if (!this.isDesktopHover()) return;
    window.clearTimeout(this.hoverCloseTimeout);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onPointerLeave() {
    if (!this.isDesktopHover()) return;
    window.clearTimeout(this.hoverCloseTimeout);
    this.hoverCloseTimeout = window.setTimeout(() => {
      if (this.matches(':hover')) return;
      this.close();
      this.closeSubmenus();
    }, 320);
  }

  onSummaryClick(event) {
    if (!this.isDesktopHover()) return;

    const url = event.currentTarget.dataset.menuLinkUrl;
    if (!url) return;

    event.preventDefault();
    window.location.href = url;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  closeSubmenus() {
    this.querySelectorAll('.header__submenu details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', false);
    });
  }
}

customElements.define('header-menu', HeaderMenu);

function setupHeaderSubmenuHover(container = document) {
  const hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  container.querySelectorAll('.header__submenu details').forEach((details) => {
    if (details.dataset.rbHoverBound === 'true') return;
    details.dataset.rbHoverBound = 'true';

    let closeTimeout = null;
    const summary = details.querySelector('summary');
    const submenu = details.querySelector(':scope > .header__submenu');

    details.addEventListener('mouseenter', () => {
      if (!hoverMediaQuery.matches) return;
      window.clearTimeout(closeTimeout);
      details.parentElement
        ?.parentElement
        ?.querySelectorAll(':scope > li > details[open]')
        .forEach((sibling) => {
          if (sibling === details) return;
          sibling.removeAttribute('open');
          sibling.querySelector('summary')?.setAttribute('aria-expanded', false);
        });
      details.setAttribute('open', '');
      summary?.setAttribute('aria-expanded', true);
    });

    details.addEventListener('mouseleave', () => {
      if (!hoverMediaQuery.matches) return;
      window.clearTimeout(closeTimeout);
      closeTimeout = window.setTimeout(() => {
        if (details.matches(':hover') || submenu?.matches(':hover')) return;
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', false);
      }, 320);
    });

    summary?.addEventListener('click', (event) => {
      if (!hoverMediaQuery.matches) return;

      const url = event.currentTarget.dataset.menuLinkUrl;
      if (!url) return;

      event.preventDefault();
      window.location.href = url;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setupHeaderSubmenuHover());
} else {
  setupHeaderSubmenuHover();
}

document.addEventListener('shopify:section:load', (event) => setupHeaderSubmenuHover(event.target));
